import { Avatar, Tooltip } from '@tryhackme/thm-ui-components';
import { UserGoal } from 'src/common/enums';
import crownImage from 'src/images/svgs/campaigns/crown.svg';
import evaluateThmImage from 'src/images/svgs/campaigns/summer-deal/evaluate-thm.svg';
import gainFundamentalSkillsImage from 'src/images/svgs/campaigns/summer-deal/gain-fundamental-skills.svg';
import getJobCyberImage from 'src/images/svgs/campaigns/summer-deal/get-job-cyber.svg';
import justLookingAroundImage from 'src/images/svgs/campaigns/summer-deal/just-looking-around.svg';
import masterNewSkillImage from 'src/images/svgs/campaigns/summer-deal/master-new-skill.svg';
import trainTeamImage from 'src/images/svgs/campaigns/summer-deal/train-team.svg';
import upskillFieldImage from 'src/images/svgs/campaigns/summer-deal/upskill-field.svg';
import { AvatarCrown, StyledCrownImage, StyledGoalImage, StyledProfileImage, StyledTooltip } from './goal-modal-image.styles';
import type { GoalModalImageProps } from './goal-modal-image.types';
const goalData = {
  [UserGoal.EVALUTE_THM]: {
    image: evaluateThmImage,
    text: <>
        Evaluate platform for
        <br /> team training
      </>
  },
  [UserGoal.GAIN_FUNDAMENTAL_SKILLS]: {
    image: gainFundamentalSkillsImage,
    text: <>
        Learn or recap foundational
        <br />
        cyber concepts
      </>
  },
  [UserGoal.GET_JOB_CYBER]: {
    image: getJobCyberImage,
    text: <>Get a job in cyber security</>
  },
  [UserGoal.JUST_LOOKING_AROUND]: {
    image: justLookingAroundImage,
    text: <>Just exploring</>
  },
  [UserGoal.MASTER_NEW_SKILL]: {
    image: masterNewSkillImage,
    text: <>Get a job in cyber security</>
  },
  [UserGoal.TRAIN_TEAM]: {
    image: trainTeamImage,
    text: <>Train my team</>
  },
  [UserGoal.UPSKILL_FIELD]: {
    image: upskillFieldImage,
    text: <>Upskill in a specific cyber field</>
  }
} as const;
export const GoalModalImage = ({
  goal,
  isPremium,
  avatar
}: GoalModalImageProps) => {
  if (isPremium && avatar) {
    return <StyledProfileImage>
        <Avatar avatarSrc={avatar} hasHover isCursorPointer={false} />
        <AvatarCrown src={crownImage} alt="Crown" />
      </StyledProfileImage>;
  }
  if (!goal) {
    return <StyledCrownImage src={crownImage} alt="Crown" />;
  }
  if (!(goal in goalData)) {
    console.warn(`[summer-deal] No image found for goal: ${goal}`);
    return null;
  }
  const {
    image,
    text
  } = goalData[goal as keyof typeof goalData];
  return <>
      <StyledGoalImage data-sentry-element="StyledGoalImage" data-sentry-source-file="goal-modal-image.tsx">
        <img src={image} alt={`Goal ${goal}`} />
        <StyledTooltip data-tooltip={`goal-${goal}`} data-sentry-element="StyledTooltip" data-sentry-source-file="goal-modal-image.tsx">
          <Tooltip arrowPosition="bottom-center" data-sentry-element="Tooltip" data-sentry-source-file="goal-modal-image.tsx">
            <p>
              Your goal:
              <br />
              {text}
            </p>
          </Tooltip>
        </StyledTooltip>
      </StyledGoalImage>
    </>;
};